import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import CommonNavbar from '../../Navbar/CommonNavbar';

const BillingAutomationHeader = ({ onSearch, disableSearch = false }) => {

    return (
        <div>
            <header>
                <nav className="nav-items">
                    <p>Billing Automation</p>
                    <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />
                </nav>
            </header>
        </div>
    )
}

export default BillingAutomationHeader


